/**
 * Волна E (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute exact path='/'>.
 * Главная. MainPage сам обрабатывает #/invite/-тосты; #login и прочие
 * корневые hash-флоу — в RootEffects (__root).
 * render.ready: MainSlider[0][8], ProductsOfDay[3][8], MainRecipes[6][8], Reviews[7][8].
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import Index from '@routes/MainPage';

export const Route = createFileRoute('/')({
  component: () => <CacheDataRoute component={Index} path='/' exact />
});
